export default __webpack_public_path__ + "static/media/Calculator.80ae1f19.svg";